export default __webpack_public_path__ + "static/media/RoomBuilderLogo_Small_Glow_NEW.ac659a57.png";